const memoryStorage = {
  _store: {},

  getItem: (key) => {
    return memoryStorage._store[key]
  },
  removeItem: (key) => {
    memoryStorage._store[key] = undefined
  },
  setItem: (key, data) => {
    memoryStorage._store[key] = data
  }
}

export const islocalStorageAvailable = function () {
  try {
    const storageTest = 'lsCheck'
    localStorage.setItem(storageTest, storageTest)
    localStorage.removeItem(storageTest)
    return true
  } catch (error) {
    return false
  }
}

export const isSessionStorageAvailable = function () {
  try {
    const storageTest = 'ssCheck'
    sessionStorage.setItem(storageTest, storageTest)
    sessionStorage.removeItem(storageTest)
    return true
  } catch (error) {
    return false
  }
}

export const getStorage = function (storageType) {
  if (storageType === 'session_storage') {
    return !isSessionStorageAvailable() ? memoryStorage : window.sessionStorage
  }
  return !islocalStorageAvailable() ? memoryStorage : window.localStorage
}

export default getStorage()



// WEBPACK FOOTER //
// ./src/utils/storage.js